// @agentx/sdk — MCP module
export { MCPConnector } from './connector'
export type { MCPConnectorConfig, MCPTool, MCPCallResult } from './connector'
export const MCP_VERSION = '0.1.0'
